import dayjs from "dayjs";
import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";
import { StatusText } from "@components";

export const DistributionTableColumn = (
  t: TFunction<"translation", undefined>,
  language: string | null,
) => {
  return [
    {
      id: 1,
      key: "date",
      name: t("INVENTORY_STOCK.DISTRIBUTION.TABLE.COLUMN.DATE"),
      className: "text-nowrap",
      render: (date: string) => (
        <Text component="p" color="subtitle2" className="text-nowrap">
          {date ? dayjs(date).format("DD-MM-YYYY") : "..."}
        </Text>
      ),
    },
    {
      id: 2,
      key: "product",
      className: "text-nowrap",
      name: t("INVENTORY_STOCK.DISTRIBUTION.TABLE.COLUMN.NAME"),
      render: (product: string) => (
        <Text color="info" weight="semibold" className="text-nowrap">
          {product ? product : "..."}
        </Text>
      ),
    },
    {
      id: 3,
      key: "openingBalance",
      className: "text-nowrap",
      name: t("INVENTORY_STOCK.DISTRIBUTION.TABLE.COLUMN.OPENING_BALANCE"),
      render: (openingBalance: number) => (
        <Text color="subtitle2">{openingBalance ? openingBalance : "..."}</Text>
      ),
    },
    {
      id: 4,
      key: "productIn",
      className: "text-nowrap",
      name: t("INVENTORY_STOCK.DISTRIBUTION.TABLE.COLUMN.PRODUCT_IN"),
      render: (productIn: number) => (
        <Text color="subtitle2">{productIn ? productIn : "..."}</Text>
      ),
    },
    {
      id: 5,
      key: "productOut",
      className: "text-nowrap",
      name: t("INVENTORY_STOCK.DISTRIBUTION.TABLE.COLUMN.PRODUCT_OUT"),
      render: (productOut: number) => (
        <Text color="subtitle2">{productOut ? productOut : "..."}</Text>
      ),
    },
    {
      id: 6,
      key: "currentBalance",
      className: "text-nowrap",
      name: t("INVENTORY_STOCK.DISTRIBUTION.TABLE.COLUMN.CURRENT_BALANCE"),
      render: (currentBalance: number) => (
        <StatusText amount={currentBalance} />
      ),
    },
    {
      id: 7,
      key: "lotNo",
      className: "text-nowrap",
      name: t("INVENTORY_STOCK.DISTRIBUTION.TABLE.COLUMN.LOT_NO"),
      render: (lotNo: number) => (
        <Text color="subtitle2">{lotNo ? lotNo : "..."}</Text>
      ),
    },
    {
      id: 8,
      key: "roomNo",
      className: "text-nowrap",
      name: t("INVENTORY_STOCK.DISTRIBUTION.TABLE.COLUMN.ROOM_NO"),
      render: (roomNo: number) => (
        <Text color="subtitle2">{roomNo ? roomNo : "..."}</Text>
      ),
    },
    {
      id: 9,
      key: "assignedTo",
      className: "text-nowrap",
      name: t("INVENTORY_STOCK.DISTRIBUTION.TABLE.COLUMN.ASSIGNED_TO"),
      render: (assignedTo: string) => (
        <Text color="subtitle2">{assignedTo ? assignedTo : "..."}</Text>
      ),
    },
  ];
};
